import { observable, action } from 'mobx';
import multipleOrderAdapter from 'adapters/MultipleOrderAdapter';

const VIEW_TYPE_MAP = {
  'ord-disp-rfq': 'rfq',
  'ord-disp-auc': 'auc',
  'ord-disp-clob': 'clob',
  'ord-disp-voice': 'voice',
  'trade-disp': 'tradeDisplay',
  'trade-disp-2': 'individual'
};

class OrderStore {
  @observable orderDataLoadInProgress = false;
  @observable viewIds = []; // Handle multiple view IDs
  @observable orders = []; // A list to store multiple views

  loadData(criteria, customErrorHandler) {
    this.orderDataLoadInProgress = true;

    const onDataLoaded = action(() => {
      this.orderDataLoadInProgress = false;
    });

    const self = this;

    return multipleOrderAdapter.loadData(criteria, customErrorHandler).then((data) => {
      // Check if the response is an array (multiple views) or a single object
      if (Array.isArray(data)) {
        // Handle multiple views
        self.orders = data; // Store all views in `orders`
        self.viewIds = data.map((view) => VIEW_TYPE_MAP[view.viewType] || 'unknown');
      } else {
        // Handle single result
        self.orders = [data]; // Wrap single result in an array
        self.viewIds = [VIEW_TYPE_MAP[data.viewType] || 'unknown'];
      }

      // Complete the loading state
      onDataLoaded();
      return data;
    }, onDataLoaded); // Handle error state
  }
}

export default new OrderStore();


// WEBPACK FOOTER //
// ./src/stores/OrderStore.js